module.exports = __webpack_public_path__ + "static/media/logo_oabgo.5f6dd5b1.png";